/**
 * Areas of interest / content categories.
 * Used in influencer profile and campaign matching.
 */
export const INTEREST_CATEGORIES = [
  'accommodation',  // 스테이
  'restaurant',     // 레스토랑
  'cafe',           // 카페
  'tour',           // 액티비티
  'ticket',         // 티켓 & 패스
  'shopping',       // 라이프스타일
  'wellness',       // 웰니스
  'other',          // 기타
] as const;

export type InterestCategory = (typeof INTEREST_CATEGORIES)[number];

/**
 * i18n key mapping for each category.
 * Use with t(`categories.${category}`) from the 'common' namespace.
 */
export const CATEGORY_I18N_KEYS: Record<InterestCategory, string> = {
  accommodation: 'categories.accommodation',
  restaurant: 'categories.restaurant',
  cafe: 'categories.cafe',
  tour: 'categories.tour',
  ticket: 'categories.ticket',
  shopping: 'categories.shopping',
  wellness: 'categories.wellness',
  other: 'categories.other',
};


/**
 * Activity types for influencer profiles.
 * User can only select one (radio button style).
 */
export const ACTIVITY_TYPES = [
  'group_purchase_affiliate',  // 공동구매/어필리에이트
  'instagram_sponsored',       // 인스타그램 협찬/광고
] as const;

export type ActivityType = (typeof ACTIVITY_TYPES)[number];


/**
 * Filming equipment types for influencer profiles.
 * Multiple selection allowed.
 */
export const EQUIPMENT_TYPES = [
  'smartphone',   // 스마트폰
  'mirrorless',   // 미러리스
  'dslr',         // DSLR
  'drone',        // 드론
  'action_cam',   // 액션캠
  'other',        // 기타
] as const;

export type EquipmentType = (typeof EQUIPMENT_TYPES)[number];


/**
 * Marital status options.
 */
export const MARITAL_STATUS = [
  'single',    // 미혼
  'married',   // 기혼
] as const;

export type MaritalStatus = (typeof MARITAL_STATUS)[number];

/**
 * Children status options.
 */
export const CHILDREN_STATUS = [
  'yes',  // 있음
  'no',   // 없음
] as const;

export type ChildrenStatus = (typeof CHILDREN_STATUS)[number];
